<div *ngIf="abierto">

  <div class="backdrop informacionModal" (click)="CerrarModal()"></div>

  <div class="panelDialogo  {{mensaje.Size}}  animated {{animacion}}">
    <div class="panelBody">

        <div class="contenido">

          <!-- Cerrar Modal -->
          <div *ngIf="mensaje.Times" style="position: relative">
            <div  class="btnCloseModal">
              <button class="btn cerrarModal" (click)="CerrarModal()" >
                <span >&times;</span>
              </button>
            </div>
          </div>

          <!-- icono fa -->
          <div *ngIf="mensaje.Icono">
            <div class="row">
              <div class="col-12">
                <div class="iconoModalInfo {{mensaje.Tipo}}">
                  <span class="{{mensaje.Icono}}"></span>
                </div>
              </div>
            </div>
            <br>
          </div>

          <!-- icono SVG -->
          <div *ngIf="mensaje.SVG">
            <div class="row">
              <div class="col-12">
                <div class="text-center">
                  <svg-icon class="iconoMensaje {{mensaje.Tipo}}" src="{{mensaje.Icono}}"></svg-icon>
                </div>
              </div>
            </div>
            <br>
          </div>

          <!-- Título -->
          <div *ngIf="mensaje.Titulo">
            <div class="row">
              <div class="col-12">
                <div class="tituloModalInfo">
                  <span>{{mensaje.Titulo}}</span>
                </div>
              </div>
            </div>

            <br>
          </div>

          <!-- Mensaje -->
          <div *ngIf="mensaje.Mensaje">
            <div class="row">
              <div class="col-12">
                <div class="mensajeModalInfo {{mensaje.Size}}" [ngClass]="{'origenHtml': mensaje.OrigenHTML}">
                  <span [innerHTML] = "mensaje.Mensaje" [ngClass]="{'textoFijoEditor Seleccionar': mensaje.OrigenHTML}"></span>
                </div>
              </div>
            </div>

          </div>

      </div>

      <div class="divisor24"></div>

      <!-- Botón aceptar -->
      <div *ngIf="mensaje.Aceptar" class="panelDialogoBtn">

        <button   class="btn boton redondeado filled botonSM botonSM botonMensaje" (click)="CerrarModal()" >
             Aceptar
         </button>

      </div>
    </div>
  </div>
</div>

